export default [
  {
    path: '/article/detail/:id',
    name: '文章内容',
    component: () => import('@/views/article/Detail'),
    meta: { breadNumber: 1 }
  },
  {
    path: '/article/list/:id',
    name: '文章列表',
    component: () => import('@/views/article/List'),
    meta: { breadNumber: 1 }
  }
]
